import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { Link } from "react-router-dom";

// Botón magnético con borde de energía. variant: primary | ghost
export const MagneticButton = ({ children, to, href, onClick, variant = "primary", testId, className = "", type }) => {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 180, damping: 16 });
  const sy = useSpring(y, { stiffness: 180, damping: 16 });

  const onMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    x.set((e.clientX - (r.left + r.width / 2)) * 0.18);
    y.set((e.clientY - (r.top + r.height / 2)) * 0.28);
  };
  const onLeave = () => {
    x.set(0);
    y.set(0);
  };

  const base =
    "group relative inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold tracking-wide transition-transform duration-300 active:scale-95";
  const styles =
    variant === "primary"
      ? "btn-glow bg-[var(--surface2)] text-[var(--ink)] hover:bg-[var(--surface)] shadow-[0_0_28px_rgba(0,199,165,0.22)]"
      : "border border-[var(--line)] text-[var(--ink)] hover:border-[var(--cyan)]/60 hover:bg-[var(--surface)]";

  const inner = (
    <motion.span ref={ref} onMouseMove={onMove} onMouseLeave={onLeave} style={{ x: sx, y: sy }} className={`${base} ${styles} ${className}`} data-testid={testId} data-cursor="cta">
      <span className="relative z-10 inline-flex items-center gap-2">{children}</span>
    </motion.span>
  );

  if (to) return <Link to={to} onClick={onClick} className="inline-block">{inner}</Link>;
  if (href) return <a href={href} onClick={onClick} className="inline-block">{inner}</a>;
  return (
    <button type={type || "button"} onClick={onClick} className="inline-block bg-transparent border-0 p-0">
      {inner}
    </button>
  );
};
